import { VendorRatesConstants } from '../Constants';
import { adminUsersServices } from '../Services';

export const VendorRateActions = {
    searchVendor
};

function searchVendor(data: any,value:any, sortByTotalCalls: any, sortByTotalConnectedCalls: any, sortByAcdFailure: any, sortByAcdSuccess: any, sortByAsrFailure: any, sortByAsrSuccess: any, sortByPddFailure: any, sortByPddSuccess: any, sortByQualityScore: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: VendorRatesConstants.SEARCH_VENDOR_REQUEST,
            data: null
        }));
        adminUsersServices.VendorRate(data,value,sortByTotalCalls, sortByTotalConnectedCalls, sortByAcdFailure, sortByAcdSuccess, sortByAsrFailure, sortByAsrSuccess, sortByPddFailure, sortByPddSuccess, sortByQualityScore)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: VendorRatesConstants.SEARCH_VENDOR_SUCCESS,
                            data: response.data   
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: VendorRatesConstants.SEARCH_VENDOR_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: VendorRatesConstants.SEARCH_VENDOR_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data
    };
}